import { Einvoice, EinvoiceValidation } from './_generatedUblInvoice'

export enum EInvoiceValidator {
  JoubiniValidator = 0,
  CustomValidation = 1,
}

export interface EInvoiceAvailableRuleSet {
  ruleset: string
  validator: EInvoiceValidator
}

export interface EInvoiceValidationResult
  extends Omit<EinvoiceValidation, 'AvailableRuleSets'> {
  AvailableRuleSets?: EInvoiceAvailableRuleSet[] | null
}

export interface EInvoiceDto extends Omit<Einvoice, 'ValidationResult'> {
  id?: string
  ValidationResult?: EInvoiceValidationResult
}
